<aside
  class="flex w-full flex-col gap-y-4 rounded-2xl bg-brand-deep-purple p-5 shadow-xl"
  aria-label="Ad preview"
>
  <div class="flex flex-row items-center justify-between">
    <p class="m-0 text-xs font-bold tracking-[0.08em] text-brand-studio uppercase">Live preview</p>
    <p class="m-0 text-xs font-semibold text-white/50">In-feed</p>
  </div>

  <!-- Device screen -->
  <div
    class="relative w-full overflow-hidden rounded-2xl border border-white/15 bg-black"
    style="aspect-ratio: 9 / 16"
  >
    @if (thumbnailUrl()) {
      <img
        [src]="thumbnailUrl()"
        alt=""
        aria-hidden="true"
        class="absolute inset-0 h-full w-full object-cover opacity-90"
      />
    }

    <div
      aria-hidden="true"
      class="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/75"
    ></div>

    <!-- TikTok chrome -->
    <div class="absolute inset-x-0 top-3 flex justify-center gap-x-4 text-xs font-bold">
      <p class="m-0 text-white/55">Following</p>
      <p class="m-0 border-b-2 border-white pb-0.5 text-white">For You</p>
    </div>

    <!-- Action rail: real counts, because a Spark ad keeps the post's engagement -->
    <div class="absolute right-3 bottom-28 flex flex-col items-center gap-y-3.5 text-white">
      <div
        aria-hidden="true"
        class="size-9 rounded-full border-2 border-white bg-gradient-to-br from-brand-studio to-brand-studio-dark"
      ></div>
      <div class="flex flex-col items-center gap-y-0.5">
        <div aria-hidden="true" class="size-5 rounded-full bg-white/90"></div>
        <p class="m-0 text-[0.625rem] font-bold tabular-nums">{{ likes() }}</p>
      </div>
      <div class="flex flex-col items-center gap-y-0.5">
        <div aria-hidden="true" class="size-5 rounded bg-white/90"></div>
        <p class="m-0 text-[0.625rem] font-bold tabular-nums">{{ comments() }}</p>
      </div>
      <div class="flex flex-col items-center gap-y-0.5">
        <div aria-hidden="true" class="size-5 rounded bg-white/90"></div>
        <p class="m-0 text-[0.625rem] font-bold tabular-nums">{{ shares() }}</p>
      </div>
    </div>

    <!-- Handle + sponsored tag -->
    <div class="absolute bottom-16 left-3 right-16 flex flex-col gap-y-1.5 text-white">
      <div class="flex flex-row items-center gap-x-2">
        <p class="m-0 truncate text-sm font-bold">{{ handle() }}</p>
        <p
          class="m-0 shrink-0 rounded bg-white/20 px-1.5 py-0.5 text-[0.625rem] font-bold tracking-[0.06em] uppercase"
        >
          Sponsored
        </p>
      </div>
    </div>

    <!-- CTA button -->
    <div class="absolute inset-x-3 bottom-3">
      <p class="m-0 rounded-lg bg-brand-studio py-2.5 text-center text-sm font-bold text-white">
        {{ callToActionLabel() }}
      </p>
    </div>
  </div>

  <!-- Verification rows -->
  <dl class="m-0 flex flex-col gap-y-2 rounded-xl bg-white/5 p-4">
    <div class="flex flex-row items-center justify-between">
      <dt class="text-sm font-semibold text-white/70">Moderation</dt>
      <dd class="m-0 text-sm font-bold" [class]="valueClass(moderationIsGood())">
        {{ moderationLabel() }}
      </dd>
    </div>
    <div class="flex flex-row items-center justify-between">
      <dt class="text-sm font-semibold text-white/70">Creator permission</dt>
      <dd class="m-0 text-sm font-bold" [class]="valueClass(permissionIsGood())">
        {{ permissionLabel() }}
      </dd>
    </div>
  </dl>
</aside>
